module.exports = __webpack_public_path__ + "img/bag2.05588676.jpg";